<script>
import OrdersApi from "@/services/orders-api";
import EstimatedDelivery from "@/components/estimated-delivery.vue";

import Swal from "sweetalert2";
import i18n from "../i18n";


/**
 * Orders-list component
 */
export default {
  components: { EstimatedDelivery },
  props: {
    orderId: {
      type: Number,
      default: 0,
    },
    isCatalogList: {
      type: Boolean,
      default: false,
    },
    priority: {
      type: Number,
      default: null,
    },
    deliveryAddress: {
      type: Object,
      default: null,
    },
    deliveryMode:{
      type: String,
      default: null,
    },
    promotionCode: {
      type: String,
      default: null,
    },
  },

  watch: {
      'orderId': function(){
        this.getOrder();
    },


  },

  computed: {
    isEstimationDeliveredEnabled() {
      return process.env.VUE_APP_FEATURE_ESTIMATION_DELIVERED_ENABLED === 'true';
    },

    showConfirmedQuantityColumn() {
      return process.env.VUE_APP_CLIENT_NAME !== "avn"
        || this.order?.status === 3;
    },

    envSupplierFullName(){
      return "Par " + process.env.VUE_APP_CLIENT_FULL_NAME
    },

    customerAsstesDiractory(){
      return process.env.VUE_APP_CUSTOMER_ASSETS_DIRACTORY
    },
    
    customerFullNameInOrder(){
      return process.env.VUE_APP_CLIENT_FULL_NAME_IN_ORDER
    },

    noteOrderLineFeatureIsEnable(){
      return process.env.VUE_APP_FEATURE_NOTE_ORDER_LINE === 'true';
    },

      orderStatus() {
        return this.order ? this.order.status : null
      },
  },

  data() {
    return {
        
      order: {lines:[], supplier:{city:{}, country:{}}, customer:{city:{}, country:{}},},
      
      //TODO to be replaced by constants !
      ORDER_STATUS_DRAFT: 0,
      ORDER_STATUS_SUBMITTED : 1,
      ORDER_STATUS_CONFIRMED : 2,
      ORDER_STATUS_DELIVERED : 3,

      previsionalDeliveryDate:null,

      availabilityDate:null,
      current_language: i18n.locale,
      currentLineIndex:null,
      inputNote: null,

        
    };
  },  
  
    mounted() {
      this.getOrder();
  },

    methods: {

      addOrderLineNote(orderLine){
        OrdersApi.addOrderLineNote(orderLine.id, this.inputNote ).then((result)=>{
          if(result){
            this.order = result;
          }
        }).finally(()=>{
          this.currentLineIndex = null,
          this.inputNote = null;
        })

      },

      showInputFormLineNote(index) {
        this.currentLineIndex = index;
        this.inputNote = this.order.lines[index].note || '';
        this.$nextTick(() => {
          const input = this.$refs[`inputNote${index}`];
          if (input) {
            input.focus();
          }
        });
      },

    getOrder() {

      OrdersApi.getOrder(this.orderId)
      .then(order => {
        this.order = order;
      })

      .finally(() => {
      })
    },

    priorityToLabel(priority) {
      switch(priority) {
        case 0: return 'low';
        case 1: return 'normal';
        case 2: return 'urgent';
        default: return 'normal';
      }
    },

    priorityToColor(priority) {
      switch(priority) {
        case 0: return 'secondary';
        case 1: return 'success';
        case 2: return 'danger';
        default: return 'success';
      }
    },

    statusToLabel(status, deliveryStatus, isPendingValidation, orderIsShipped) {
      switch(status) {
        case 0: return isPendingValidation ? 'pendingValidation' : 'draft';
        case 1: return 'new';
        case 2: return 'confirmed';
        case 3: return  orderIsShipped ? 'orderIsShipped' : deliveryStatus == 1 ? 'partiallyDelivered' : 'delivered';
        case 4: return 'canceled';
        default: return '_';
      }
    },

    deliveryStatusToLabel(deliveryStatus,status){
      if(status!=2 && status!=3){
        return '_'
      }
          switch(deliveryStatus){
            case 0 : return 'notDelivered';
            case 1 : return 'partiallyDelivered';
            case 2 : return 'delivered';
            default: return 'notDelivered'
          }
    },

    deliveryStatusToColor(deliveryStatus,status){
      if(status!=2 && status!=3){
        return '_'
      }
      switch(deliveryStatus){
        case 0 : return 'danger';
        case 1 : return 'info';
        case 2 : return 'success';
        default: return 'danger'
      }
    },

    // Omnipharm only: "Expediée" badge in dark green (white text) instead of navy; the same
    // #146c43 as the delivery line under it (estimated-delivery.vue, .ed-inline).
    shippedBadgeStyle(status, orderIsShipped) {
      return this.isEstimationDeliveredEnabled && status == 3 && orderIsShipped
        ? { backgroundColor: '#146c43', color: '#fff' }
        : {};
    },

    statusToColor(status, deliveryStatus , isPendingValidation, orderIsShipped ) {
      switch(status) {
        case 0: return isPendingValidation ? 'danger' : 'secondary';
        case 1: return 'danger';
        case 2: return 'warning';
        case 3: return orderIsShipped ? 'primary' : deliveryStatus == 1 ? 'info' : 'success'; 
        case 4: return 'secondary';
        default: return 'black';
      }
    },

    outstandingStatusToLabel(status){
      switch(status) {
        case 0: return 'OK';
        case 1: return 'Bloqué';
        case 2: return 'En cours';
        case 3: return 'Non Versée';
        case 4: return 'Sage.Exch';
        default: return '';
      }
    },

    billingStatusToLabel(status,orderStatus){
      if(orderStatus!=2 && orderStatus!=3){
        return '_'
      }
      switch(status){
        case 0: return 'notBilled';
        case 1:return 'partiallyBilled';
        case 2 :return 'billed';
        default: return '_'
      }
    },

    billingStatusToColor(status,orderStatus){
      if(orderStatus!=2 && orderStatus!=3){
        return '_'
      }
      switch(status){
        case 0: return 'danger';
        case 1:return 'warning';
        case 2 :return 'success';
        default: return '_'
      }
    },

    editConfirmedQuantity: function(line, index) {

      if (!this.order.isProcessable || this.order.status > 1) {
        return;
      }

      line.edit=true;
      let input = this.$refs['confirmedQuantityEdit-' + index][0];
      input.focus();
    },


    saveConfirmedQuantity(line) {
      
      if (line.confirmedQuantity == null) {
        line.confirmedQuantity = line.quantity
      }

      OrdersApi.saveConfirmedQuantity(line.id, line.confirmedQuantity)
        .then((order) => {
          if(order){
                line.edit=false;
                this.order = order;
                if(line.quantity != line.confirmedQuantity && line.confirmedQuantity != null){
                  this.availabilityDate=null
                }
          }
          })
    },

    confirm() {
      Swal.fire({
        title: i18n.t("order.alerts.confirm.title"),
        text: i18n.t("order.alerts.confirm.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t("order.alerts.confirm.confirmButtonText"),
        cancelButtonText:i18n.t("order.alerts.confirm.cancelButtonText")
      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.confirmOrder(this.orderId)
            .then((order) => {

              if (order) {
                this.order = order;
              } 
            })
        }
      });
    },

    cancelOrder() {
      Swal.fire({
        title: i18n.t("order.alerts.cancel.title"),
        text: i18n.t("order.alerts.cancel.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#6c757d",
        confirmButtonText: i18n.t("order.alerts.cancel.confirmButtonText"),
        cancelButtonText: i18n.t("order.alerts.cancel.cancelButtonText")
      })
      .then(result => {
        if (result.value) {
          OrdersApi.canceledPartnerOrder(this.orderId).then(order => {
            if (order) {
              this.order = order;
            }
          });
        }
      });
    },


    validateOrder(){
      Swal.fire({
        title: i18n.t("order.alerts.validate.title"),
        text: i18n.t("order.alerts.validate.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t("order.alerts.validate.confirmButtonText"),
        cancelButtonText: i18n.t("order.alerts.validate.cancelButtonText")
      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.validateOrder(this.orderId)
            .then((order) => {
              if (order) {
                this.order = order;
              }
            })
        }
      });
    },

    deliverOrder() {
      Swal.fire({
        title: i18n.t("order.alerts.deliver.title"),
        text: i18n.t("order.alerts.deliver.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: i18n.t("order.alerts.deliver.confirmButtonText"),
        cancelButtonText: i18n.t("order.alerts.deliver.cancelButtonText")
      })
      
      .then(result => {
        if (result.value) {

          OrdersApi.deliverOrder(this.orderId)
            .then((order) => {
              if (order) {
                this.order = order;
              }
            })
        }
      });
    },

    editBackOrder(/*line*/){
      /*BackOrdersApi.editBackOrder(line==null ? null : line.id)
      .then((order) => {
        if (order) {
          this.order = order;
        }
      })*/
    },

    exportEXCEL(orderId){
      OrdersApi.exportEXCEL(orderId)
    },


    editOrderLine(item){
      OrdersApi.editLineToOrder(this.order.id, item.itemId, item.editedQuantity, this.selectedSupplier, this.selectedPromotion,false) 
      .then(order => {
        if(order) {
          this.orderLines = order.lines;
          this.order = order; 

          this.$root.$emit('order-changed-event', this.order.lines ? this.order.lines.length : 0)
        }
      }).catch((error) => {
          this.$emit('updatePanacheItem', error)
      })
      .finally(() => {
        item.isOrderQuantityEdit = false
        
      }) 

      
    },

    removeOrderLine(item){

        Swal.fire({
        title: i18n.t('order.alerts.delete.title'),
        html: item.itemTitle,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        cancelButtonText: i18n.t('order.alerts.delete.cancelButtonText'),
        confirmButtonText:  i18n.t('order.alerts.delete.confirmButtonText')
        }).then(result => {
        if (result.value) {
          OrdersApi.removeOrderLine(this.order.id, item.itemId,this.selectedSupplier,false)
          .then(order => {
            if (!order) {
              this.clearAll()
            } else {
              this.orderLines = order.lines;
              this.order = order;
            }

            this.$root.$emit('order-changed-event', this.order.lines ? this.order.lines.length : 0)
          }).catch((error) => {
            this.$emit('removePanacheItem', error)
        })
        }
        });
    },

    clearAll(){
      
      this.clearOrder()

       

          this.selectedCustomer = null;

          this.selectedBrand = null;
          this.selectedGroup = null;
          this.selectedSubGroup = null;

          this.reference = null;
        

        this.$root.$emit('order-changed-event', this.order.lines ? this.order.lines.length : 0)
        
    },

    clearOrder() {
        this.orderLines=[]
        this.order= {discountAmount: 0, total: 0, taxes: 0, vat: 0, totalWithTaxes: 0, deliveryAddress:'',totalPara:0,totalPharma:0, totalBeforeDiscount: 0};

        //these cookies are written without a domain (host-only), they must be expired the same way
        document.cookie = 'drafto' + '=; Max-Age=0; path=/';
        document.cookie = 'draftoc' + '=; Max-Age=0; path=/';

        this.$root.$emit('order-changed-event', this.order.lines ? this.order.lines.length : 0)
    },

  },

}

</script>

<template>
  <div>
    <div v-if="!isCatalogList" class="row pl-lg-4 pr-lg-4 pt-4 pr-0 pl-0 d-print-none">
      <div class="col-xl-3 col-lg-3 col-md-3 col-4 text-left">
            <div class="form-group ">
              <label class="text-dark font-weight-bold">Etat</label>
              <h5 v-if="order && order.status!=null "><b-badge class="font-weight-bold" href="#" :variant="statusToColor(order.status, order.deliveryStatus , order.isPendingValidation, order.orderIsShipped)" :style="shippedBadgeStyle(order.status, order.orderIsShipped)" style="cursor: text !important;">{{$t("ordersMenu.statusLabel."+statusToLabel(order.status, order.deliveryStatus, order.isPendingValidation, order.orderIsShipped))}}</b-badge></h5>
            </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-3 col-4 text-left">
            <div class="form-group ">
              <label class="text-dark font-weight-bold">Priorité</label>
              <h5 v-if="order">  <span  v-if="order.priority == null" class="text-muted font-weight-bold">_</span> <b-badge v-if="order.priority != null" href="#" class="font-weight-bold" :variant="order.priority == 2 ? 'danger' : order.priority == 1 ? 'warning' : 'success'"  style="cursor: text !important;">{{ order.priority == 2 ? 'Urgente' : order.priority == 1 ? 'Normale' : 'Basse Priorité' }}</b-badge></h5>
            </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-3 col-4 text-left">
            <div class="form-group ">
              <label class="text-dark font-weight-bold">Livraison</label>
              <h5 v-if="order">  <span  v-if="order.deliveryMode == null" class="text-muted font-weight-bold">_</span> <b-badge v-if="order.deliveryMode != null" href="#" class="" variant="secondary"  style="cursor: text !important;">{{ order.deliveryMode == '1' ? 'Par le client' : this.envSupplierFullName }}</b-badge></h5>
            </div>
      </div>

      <div class="col-xl-3 col-lg-3 col-md-3 col-3 text-right">
        <a href="javascript:window.print()">
            <b-button variant="outline-secondary" class="font-weight-bold" style="width: 100%" size="lg" >
              <i class="fa fa-print font-size-16 align-middle mr-lg-2"></i> <span class="d-none d-lg-inline">{{$t("order.buttons.print")}}   </span>
            </b-button>
        </a>
      </div>





      <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-4 text-left">
            <div class="form-group ">
              <label>{{$t("ordersMenu.list.header.status")}}</label>
              <h5 v-if="order && order.status!=null "><b-badge href="#" :variant="deliveryStatusToColor(order.deliveryStatus,order.status)">{{$t("ordersMenu.statusLabel."+deliveryStatusToLabel(order.deliveryStatus,order.status))}}</b-badge></h5>
            </div>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-3 col-4">
            <div class="form-group text-right float-right">
              <label>{{$t("order.credit.label")}}</label><br>
              <h5 v-if="order"><b-badge href="#" :variant="billingStatusToColor(order.billingStatus,order.status)">{{$t("ordersMenu.billingStatus."+billingStatusToLabel(order.billingStatus,order.status))}}</b-badge></h5>
            </div>
      </div> -->
      <!-- <div class="col-xl-3 col-lg-3 col-md-3 col-12 text-right pb-2">
        <div>
            <div class="form-group">
                <label class="text-right ">{{$t("order.previsionalDeliveryDate.label")}} </label><br>
                <span  class="text-info font-weight-bold font-size-16 pl-2 pb-0 mb-0">{{order.provisionalDeliveryDate ? order.provisionalDeliveryDate : '_'}}</span> 
            </div> <br>
          </div>
      </div> -->

    </div>

    <div v-if="!isCatalogList && isEstimationDeliveredEnabled && order && order.estimationDeliveredDate" class="row pl-lg-4 pr-lg-4 pl-0 pr-0 pt-2 d-print-none">
      <div class="col-12">
        <estimated-delivery layout="panel" :date="order.estimationDeliveredDate" :delivered="order.estimationDeliveredStatus === true" :ordered-at="order.submissionDate" />
      </div>
    </div>

    <div class="row " :class="isCatalogList ? '' : 'p-lg-4 p-0 mt-2'">
      <div class="col-12">
        <div class="card  print-no-border">
          <div class="card-body">
            <div class="invoice-title">

              <div class="row">
                <div class="col-xs-12 col-sm-6 d-none d-lg-inline d-print-inline text-left">
                  <img class="" :src="customerAsstesDiractory + 'logo.png'" alt height="40" />
                </div>
                <div class="col-xs-12 col-sm-6 d-lg-none d-print-none text-left">
                  <img class="" :src="customerAsstesDiractory + 'logo.png'" alt height="40" />
                </div>

                <div class="col-xs-12 pt-4 pt-sm-0 col-sm-6 text-left text-sm-right">
                   <h4 class="text-dark font-size-16">{{$t("order.title")}} <strong>{{order.extId? order.extId  : "_" }}</strong> <br></h4>
                </div>
              </div>
              <!-- <hr/> -->


              <div class="row pt-2 d-none d-lg-flex d-print-flex">
                <div class="col-xs-12 col-sm-6 text-left">
                  <span class="font-size-14 font-weight-bold text-dark">{{ customerFullNameInOrder }}</span><br/>
                  <!-- <span class="font-size-14 text-primary"></span><br/> -->
                </div>

                <!-- <div class="col-xs-12 col-sm-6 text-sm-right">
                    <address>
                    <strong>{{$t("order.header.client")}} :</strong> 
                    <br /><strong>{{this.order.customer.name}}</strong>
                    <br />{{this.order.customer.address}}
                    <span class="font-size-14">{{this.order.customerName}}</span>
                    <br/><br /><i v-if="order.customerPhone" class="fas fa-phone text-muted font-size-12"/> {{this.order.customerPhone}}
                  </address>
                </div> -->
              </div>

              <div class="row pt-0 pb-2 d-none d-lg-flex d-print-flex">
                <div class="col-xs-12 col-sm-6 text-left">
                  <span class="font-size-12 text-dark"><i>{{this.order.supplierFullAddress}}</i></span><br/>
                  <!-- <span class="font-size-12 text-primary">Web : www.sia-am.com </span><br/>
                  <span class="font-size-12 text-primary">E-Mail : commercial@sia-am.com </span> -->
                </div>

                
              </div>

             
              
            </div>

            
            
            <!-- <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <address>
                  <strong>{{$t("order.header.supplier")}}</strong> {{this.order.supplierName}}
                  <br />{{this.order.supplierFullAddress}}
                  <br />{{this.order.supplierShortAddress}}
                  <br/><br /><i v-if="order.supplierPhone" class="fas fa-phone text-muted font-size-12"/> {{this.order.supplierPhone}}
                  
                  <br />
                </address>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12  text-md-right">
                <address>
                  <strong>{{$t("order.header.client")}} :</strong> {{this.order.customerName}}
                  <br />{{this.order.customerShortAddress}}
                  <br/><br /><i v-if="order.customerPhone" class="fas fa-phone text-muted font-size-12"/> {{this.order.customerPhone}}
                </address>
              </div>
            </div> -->
            
            <div class="row pt-4">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <address>
                    <strong class="text-dark font-size-14">{{$t("order.header.client")}}</strong> <br/>
                    <span class="font-size-14">{{this.order.customerName}}</span>
                  </address>
              </div>
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-md-right">
                <address>
                  <strong class="text-dark font-size-14">{{$t("order.header.deiveryAddress")}}</strong>
                  <!-- <br /><span class="font-size-16">{{this.isCatalogList ? this.deliveryAddress : this.order.deliveryAddress}}</span> -->
                  <br /><span class="font-size-14"> {{ this.deliveryAddress ? deliveryAddress.address : this.order.deliveryAddress}}</span>
                </address>
              </div>
            </div>

            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                <address>
                  <strong class="text-dark font-size-14" v-if="order.submissionDate && order.submissionDate.length">{{$t("order.header.date")}}</strong>
                  <br /><span class="font-size-14">{{order.submissionDate}}</span>
                </address>
              </div>
              <!-- <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 text-md-right">
                <address>
                  <strong>{{$t("order.header.deliveryMode.label")}}</strong>
                  <br />        
                  {{this.isCatalogList ? this.deliveryMode : this.order.deliveryMode }}
                </address>
              </div> -->
            </div>

            <!-- <div class="row">
              <div class="col-6 ">
                <address>
                  <strong>{{$t("order.header.date")}}</strong>
                  <br />{{order.submissionDate}}
                </address>
              </div>
              <div class="col-6 mt-3 text-right">
              </div>
            </div> -->
              <!-- <div class="p-2 mt-3">
                <h3 class="font-size-16">{{$t("order.orderLinesTable.title")}} </h3>
              </div> -->
            <div class="table-responsive mt-4">
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 150px;" class="d-none d-md-table-cell">{{$t("order.orderLinesTable.ref")}}</th>
                    <th style="width: 300px;">{{$t("order.orderLinesTable.name")}}</th>
                    <th style="width: 250px;" class="text-right">{{$t("order.orderLinesTable.price")}}</th>
                    <th style="width: 120px;" class="text-right">{{$t("order.orderLinesTable.qte")}}</th>
                    <th v-if="showConfirmedQuantityColumn" style="width: 120px; background-color: rgb(191, 234, 255,0.5);" class="text-right d-none d-md-table-cell">{{$t("order.orderLinesTable.confirmed")}}</th>
                    <!-- <th style="width: 120px;" class="text-right">{{$t("order.orderLinesTable.salesUnit")}}</th> -->
                    <!-- <th style="width: 200px;" class="text-right d-none d-md-table-cell">{{$t("order.orderLinesTable.discount")}}</th> -->
                    <th style="width: 250px;" class="text-right">{{$t("order.orderLinesTable.priceHT")}}</th>
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="(line,i) in this.order.lines" :key="i">

                      <td class="d-none d-md-table-cell">{{ line.ref }}</td> 
                      <td>  
                              <a v-if="!line.isGratuity && orderStatus == 0 && isCatalogList" :title="$t('parameters.hover.delete')" href="javascript:void(0);"  @click="removeOrderLine(line)" :class="line.id ? '' : 'd-none'" class="action-icon text-danger">
                                  <i class="fas fa-trash-alt mr-2" />
                              </a> 
                                {{ line.itemTitle }}
                                  <div v-if="noteOrderLineFeatureIsEnable && ((order && order.status == 0) && currentLineIndex != i)" class="float-right"> 
                                    <img v-if="line && line.note"  title="Modifier la note" src="@/assets/images/EditNote.svg" class="float-right" alt height="25" style="cursor: pointer;" @click="showInputFormLineNote(i)" />
                                    <img v-else  title="Ajouter une note à la Ligne commande" src="@/assets/images/AddNote.svg" class="float-right" alt height="25" style="cursor: pointer;" @click="showInputFormLineNote(i)" />
                                  </div>

                                  <div v-if="noteOrderLineFeatureIsEnable && currentLineIndex === i">
                                    <div class="col-12 mt-2">
                                        <b-input-group>
                                          <b-form-input
                                            id="reference-search-input"
                                            v-model="inputNote"
                                            placeholder="Ajouter une note à la Ligne commande"
                                            @keyup.enter="addOrderLineNote(line)"
                                            class="text-dark font-weight-bold font-size-12"
                                            maxlength="200"
                                          ></b-form-input>

                                          <template v-slot:append>
                                            <b-button size="sm" variant="success" @click="addOrderLineNote(line)">
                                              <span class="font-weight-bold">
                                                <i class="bx bx-check font-weight-bold font-size-16 pr-1 pl-1 text-white align-middle"></i>
                                              </span>
                                            </b-button>
                                          </template>
                                        </b-input-group>

                                        <!-- Character counter below -->
                                        <small class="text-muted">
                                          {{ inputNote.length }} / 200 caractères
                                        </small>
                                    </div>
                                  </div>
                                  <div v-else-if="noteOrderLineFeatureIsEnable && line && line.note" class="text-secondary" style="font-size: 10px;">{{ line.note}} </div>

                      </td> 
                     
                      <td class="text-right">{{ line.price }}</td>
                      <td class="text-right">
                        <span v-if="!line.isOrderQuantityEdit" class="text-black">{{ line.quantity }}</span>
                              <a  v-if="!line.isOrderQuantityEdit && !line.isGratuity && orderStatus == 0 && isCatalogList" @click="line.isOrderQuantityEdit = true" :title="$t('parameters.hover.editQty')" href="javascript:void(0);" :class="line.itemId ? '' : 'd-none'" class="action-icon text-warning">
                                  <i class="fas fa-pencil-alt  ml-2 font-size-13"  @click="line.isOrderQuantityEdit = true; line.editedQuantity = line.quantity;"/>
                              </a>
                              <!-- <i v-if="line.isGratuity" class="fas fa-star text-info invisible  ml-2 font-size-12 " /> -->

                              <div v-if="line.isOrderQuantityEdit" class="input-group input-group-sm pull-right mb-0" >
                                <b-form-input v-model="line.editedQuantity" type="number"  size="sm" class="no-shadow p-1" @keyup.native.enter="editOrderLine(line)"></b-form-input>
                                  <div class="input-group-append"  size="sm" >
                                    <b-button variant="link"  size="sm" title="Changer la quantité"><i class="font-size-12 fas fa-pencil-alt text-warning" @click="editOrderLine(line)"></i></b-button>
                                  </div>
                              </div>
                      </td>

                      <td v-if="showConfirmedQuantityColumn" class="text-right text-dark font-weight-bold d-none d-md-table-cell font-size-16;"  style="background-color:rgb(191, 234, 255,0.5);">
                        <div v-if="!isCatalogList">
                          <div  :class="line.quantity != line.confirmedQuantity && line.confirmedQuantity != null ? 'text-danger' : ''"  >
                            {{ line.confirmedQuantity != null ? line.confirmedQuantity : line.quantity }} 


                          </div>

                        </div>

                        


                      </td>
                      <!-- <td class="text-right">{{line.itemSalesUnit}} </td> -->
                      <!-- <td style="background-color: #f6d39a#83bff4; border: 1px solid;"> -->
                       
                      <!-- <td class="text-right">{{ line.discountAmount }}</td> -->
                      <!-- <td class="text-right d-none d-md-table-cell">{{ line.totalDiscountRate != '0' ? line.totalDiscountRate + '%' : '' }} </td> -->

                      <!-- TODO ce calcul doit etre faut du cote serveur ou avec le bon nombre de chiffres apres la virgule -->
                      <td class="text-right">{{ line.lineTotalAmount }}</td>

                    </tr>
              

                </tbody>
              </table>
            </div>

              <div class="row">
                 <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-xs-12 ">
                   <h5 class="m-0 float-right  text-dark font-weight-bold">Total HT</h5>
                 </div>
                 <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12  ">
                   <h5 class="m-0 float-right  text-dark font-weight-bold">{{this.order.totalBeforeDiscount}} </h5>
                 </div>
               </div>

              <div class="row pt-4">
                 <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-xs-12 ">
                    <span class="float-right text-dark ">T.V.A</span>
                 </div>
                 <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12  ">
                   <span class="m-0 float-right text-dark ">{{this.order.vatAmount}} </span>
                 </div>
               </div>

              <div class="row pt-4">
                 <div class="col-xl-10 col-lg-9 col-md-9 col-sm-12 col-xs-12 ">
                    <h5 class="m-0 float-right text-dark font-weight-bold">Total TTC</h5>
                 </div>
                 <div class="col-xl-2 col-lg-3 col-md-3 col-sm-12 col-xs-12  ">
                   <h5 class="m-0 float-right text-dark font-weight-bold">{{this.order.totalWithTaxes}} </h5>
                 </div>
               </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="!isCatalogList" class="row p-4" >
       <div class="col-md-2 col-sm-6 p-1 text-left">
        <b-button variant="secondary" style="width: 100%" size="lg" @click="cancelOrder" :disabled="order.status != 1" v-if="order.isProcessable">
            <i class="fas fa-exclamation-triangle font-size-16 align-middle mr-2"></i> {{$t("order.buttons.cancel")}}
        </b-button>
      </div>
      <div class="col-md-2 col-sm-12 p-1 text-right">
        <b-button variant="warning" style="width: 100%" size="lg" @click="confirm" :disabled="order.status != 1" v-if="order.isProcessable">
                 <i class="fas fa-check-double font-weight-bold font-size-16 align-middle mr-2"></i> {{$t("order.buttons.confirm")}}
            </b-button>
      </div>
      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none" > 
        <b-button variant="success" style="width: 100%" size="lg" @click="deliverOrder" :disabled="order.status != 2" v-if="order.isProcessable" >
                <i class="fas fa-truck-loading font-weight-bold font-size-16 align-middle mr-2"></i>{{$t("order.buttons.deliver")}}
            </b-button>
      </div> 
      <div class="col-md-10 col-sm-4 p-1 text-right d-print-none" >
        
      </div>
       <div class="col-md-2 col-sm-4 p-1 text-right d-print-none">
        <b-button variant="light" style="width: 100%" size="lg" @click.prevent="exportEXCEL(orderId)">
          <i class="fas fa-file-excel font-size-16 align-middle mr-2"></i> {{$t("order.buttons.export")}}  
        </b-button>
      </div>
      <div class="col-md-2 col-sm-4 p-1 text-right d-print-none text-right" > 
        <a href="javascript:window.print()">
            <b-button variant="light" class="font-weight-bold" style="width: 100%" size="lg" >
              <i class="fa fa-print font-size-16 align-middle mr-2"></i> {{$t("order.buttons.print")}}   
            </b-button>
        </a>
      </div>

    </div> -->
    <div class="text-right pr-lg-4 pl-lg-4 pr-0 pl-0 d-print-none d-flex justify-content-end">
      <b-button
        variant="outline-secondary"
        v-if="order.isPendingValidation"
        @click="cancelOrder()"
        class="mr-2"
      >
        <i class="fa fa-times font-size-14 align-middle mr-lg-2"></i>
        <span class="text-uppercase font-size-14">
          {{$t("order.buttons.cancelOrder")}}
        </span>
      </b-button>

      <b-button
        variant="outline-success"
        v-if="order.isPendingValidation"
        @click="validateOrder()"
      >
        <i class="fa fa-check font-size-14 align-middle mr-lg-2"></i>
        <span class="text-uppercase font-size-14">
          {{$t("order.buttons.validation")}}
        </span>
      </b-button>
    </div>

    <div v-if="!isCatalogList" class="row mt-2 pr-lg-4 pl-lg-4 pr-0 pl-0 mb-4 d-print-none">
      
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pt-4 pt-lg-0 " v-if="order.message">
        <div class="card  h-100">
          <div class="card-body">
            <h4 class="card-title mb-4 text-primary">Notes de Commande</h4>
            <div class="media mb-4" v-if="order.message">
              <div class="mr-3">
                <!-- <img
                  class="media-object rounded-circle avatar-xs"
                  alt
                  src="@/assets/images/users/avatar-1.jpg"
                /> -->

                <i class=" fas fa-user text-primary" style="font-size:15px;"/>

              </div>
              <div class="media-body" >
                <h5 class="font-size-13 mb-1 font-weight-bold">{{this.order.messageUserName}}</h5>
                <p class="text-muted mb-1">
                    {{this.order.message }} </p>
        
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div v-if="!isCatalogList" class="row pr-4 pl-4 mb-4 d-print-none">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pt-4 pt-lg-0 ">
        <div class="card  h-100">
          <div class="card-body">
            <h4 class="card-title mb-4 text-danger">{{$t("order.history.title")}} </h4>

            <div class="hori-timeline">
              <ul class="list-inline events">

          

                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-secondary font-weight-bold font-size-16 mb-4">{{order.date}}</p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-secondary bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-secondary"><i class="fab fa-firstdraft h2 text-secondary mr-2"></i>{{$t("order.history.timeline.draft")}}</h5>
                    </div>
                  </div>
                </li>


                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-primary font-weight-bold font-size-14 mb-4">{{order.submissionDate ? order.submissionDate : '-'}} <span v-if="order.submissionUserName" class="font-weight-normal font-size-14"><br> ({{order.submissionUserName}})</span></p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-primary bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-primary"><i class="bx bx-copy-alt h2 text-primary mr-2"></i>{{$t("order.history.timeline.new")}}</h5>
                    </div>
                  </div>
                </li>

            
                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-info font-weight-bold font-size-16 mb-4">{{order.confirmationDate ? order.confirmationDate : '-'}}</p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-info bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-info"><i class="bx bx-package h2 text-info mr-2"></i>{{$t("order.history.timeline.confirmed")}}</h5>
                    </div>
                  </div>
                </li>

      
                <li class="list-inline-item event-list">
                  <div class="mt-4">
                    <div class="px-3">
                      <p class="text-success font-weight-bold font-size-16 mb-4">{{order.deliveryDate ? order.deliveryDate : '-'}}</p>
                    </div>

                    <div class="event-up-icon">
                      <i
                        class="bx bx-up-arrow-circle h1 text-success bx-fade-up-hover up-arrow-icon"
                      ></i>
                    </div>
                    <div class="event-date mt-3">
                      <h5 class="text-success"><i class="bx bxs-truck h2 text-success  mr-2"></i>{{$t("order.history.timeline.delivered")}}</h5>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
    </div> -->



  </div>
</template>
<style >
.modal-dialog.modal-xl {
    min-width: 95% !important;
}

@media print {
  .print-no-border{
      border: 0;
      border-color: white !important;
  }
}

</style>
